<template>
  <div 
    class="background-main">
    <div
      class="blur">
      <v-container
        style="height: 100%;">
        <v-row 
          style="height: 100%;"
          align="center" 
          justify="center">
          <v-col 
            cols="12" 
            md="4" 
            sm="6">
            <v-card
              class="border-radius my-10"
              style="background: #FFFFFF40; box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;">
              <div class="pa-16 py-8">
                <v-img
                  class="ma-auto"
                  contain
                  width="150"
                  height="150"
                  alt="vuetify"
                  :src="require('@/assets/logo/favicon.png')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        color="#B71C1C">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <div
                  class="d-flex align-center justify-center mx-auto mt-4"
                  style="width: 110px;">
                  <v-img 
                    v-for="(item, index) in list.logo"
                    :key="index"
                    contain
                    width="30"
                    height="30"
                    alt="kominfo" 
                    :src="item"
                    class="ma-auto mx-2">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="14"
                          indeterminate 
                          color="#B71C1C">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </div>

              <div 
                class="px-5 pb-8"
                style="background: #FFF; border-radius: 15px;">
                <div class="px-3 mb-6 text-center">
                  <p class="title mb-2">
                    Matur Dokter
                  </p>

                  <p 
                    class="body-2 font-weight-light line-text-second">
                    Sistem Layanan Kesehatan Masyarakat Kabupaten Klaten
                  </p>
                </div>

                <ValidationObserver 
                  ref="observer">
                  <v-form class="text-left mb-6">
                    <ValidationProvider 
                      name="Username" 
                      rules="required|email" 
                      v-slot="{ errors }">
                      <v-text-field
                        v-on:keyup.enter="login"
                        outlined
                        dense
                        rounded
                        color="#B71C1C"
                        placeholder="Username"
                        v-model="form.username"
                        vvvv-uppercase
                        :error-messages="errors"
                        required>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider
                      name="Password"
                      rules="required|min:5|max:20"
                      v-slot="{ errors }">
                      <v-text-field
                        v-on:keyup.enter="login"
                        class="mt-2 mb-1"
                        outlined
                        color="#B71C1C"
                        dense
                        rounded
                        placeholder="Password"
                        v-model="form.password"
                        :type="show ? 'text' : 'password'"
                        :counter="20"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show = !show"
                        :error-messages="errors"
                        required>
                      </v-text-field>
                    </ValidationProvider>
                  </v-form>
                </ValidationObserver>

                <div 
                  class="text-center">
                  <v-alert 
                    type="error" 
                    text 
                    dense 
                    prominent 
                    v-show="message.error !== ''"
                    v-html="message.error">
                  </v-alert>

                  <v-btn
                    block
                    color="#B71C1C"
                    elevation="0"
                    rounded
                    height="40"
                    :disabled="process.form"
                    :loading="process.form"
                    v-on:keyup.enter="login"
                    @click="login"
                    class="body-2 font-weight-bold white--text text-capitalize">
                    <v-icon size="20" class="mr-2">mdi-login-variant</v-icon>
                    Masuk Admin
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  import { auth } from '@/plugins/Firebase';
  export default {
    data() {
      return {
        show: false,
        list: {
          logo: [
            require('@/assets/logo/logo_1.png'),
            require('@/assets/logo/logo_2.png'),
            require('@/assets/logo/logo_3.png')
          ]
        },
        form: {
          username: '',
          password: '',
          fcm: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      
    },
    methods: {
      async login () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          this.form.fcm = this.$store.state.fcm
          
          await post('auth/admin/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            if (res.code === 200) {
              let user = res.data,
                  menu = [
                    {
                      label: 'Dashboard',
                      icon: 'mdi-view-dashboard',
                      link: '/dashboard'
                    },
                    {
                      label: 'Layanan',
                      icon: 'mdi-alarm-bell',
                      link: '/service'
                    },
                    {
                      label: 'PPD',
                      icon: 'mdi-car-brake-alert',
                      link: '/ppd'
                    },
                    {
                      label: 'Pengguna',
                      icon: 'mdi-account-group',
                      link: '/user'
                    },
                    {
                      label: 'Informasi Kesehatan',
                      icon: 'mdi-forum-outline',
                      link: '/consultant'
                    },
                    {
                      label: 'Chat Pending',
                      icon: 'mdi-forum-remove-outline',
                      link: '/pending'
                    },
                    {
                      label: 'Log Call',
                      icon: 'mdi-phone-log-outline',
                      link: '/log'
                    },
                    {
                      label: 'Berita',
                      icon: 'mdi-newspaper',
                      link: '/news'
                    },
                    {
                      label: 'Pengumuman',
                      icon: 'mdi-bullhorn',
                      link: '/announcement'
                    },
                    {
                      label: 'Pemeritahuan',
                      icon: 'mdi-bell-cog-outline',
                      link: '/notification'
                    },
                    {
                      label: 'Pengaturan',
                      icon: 'mdi-shape-outline',
                      link: '/setting'
                    }
                  ]

              // JIKA BELUM TERDAFTAR DI GOOGLE AUTH
              auth.createUserWithEmailAndPassword(this.form.username, this.form.password)
              .then(resGoogle => {

                TokenService.saveToken(
                  res.data.token,
                  JSON.stringify(user),
                  JSON.stringify(menu)
                )

                TokenService.saveReload(false)

                window.location = `${process.env.BASE_URL}dashboard`

              }).catch(error => {
                // JIKA SUDAH TERDAFTAR DI GOOGLE AUTH
                auth.signInWithEmailAndPassword(this.form.username, this.form.password)
                .then(resGoogle => {
                  
                  TokenService.saveToken(
                    res.data.token,
                    JSON.stringify(user),
                    JSON.stringify(menu)
                  )

                  TokenService.saveReload(false)

                  window.location = `${process.env.BASE_URL}dashboard`

                }).catch(error => {
                  
                  TokenService.saveToken(
                    res.data.token,
                    JSON.stringify(user),
                    JSON.stringify(menu)
                  )

                  TokenService.saveReload(false)

                  window.location = `${process.env.BASE_URL}dashboard`

                })
              })
                  
              // TokenService.saveToken(
              //   res.data.token,
              //   JSON.stringify(user),
              //   JSON.stringify(menu)
              // )

              // TokenService.saveReload(false)

              // window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>

<style>
  .background-main {
    background-image: url('../../assets/background/bg_basic_5.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    background-attachment: fixed;
  }

  .blur {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    width: 100%;
    height: 100%;
  }
</style>